/* eslint-disable */
import 'jquery.cookie';

import ls from '@/js/common/Domain/Service/local-storage';
import CountryEntity from "@/js/common/Domain/Entity/Country";
import CountriesRepository from "@/js/common/Domain/Repository/Countries";
import ResortEntity from "@/js/common/Domain/Entity/Resort";
import ResortsRepository from "@/js/common/Domain/Repository/Resorts";
import HotelEntity from "@/js/common/Domain/Entity/Hotel";
import HotelsRepository from "@/js/common/Domain/Repository/Hotels";
import getMinPriceByCriteriasService from "@/js/common/Domain/Service/getMinPriceByCriterias";
import DestinationModel from "./DestinationModel";
import DestinationService from "@/js/common/Domain/Service/Destination";
import DestinationSearchFieldView from "@/js/desktop/View/destination/DestinationSearchFieldView";
import tourCriteriasForMinPricesHydrator from "@/js/common/Domain/Hydrator/tourCriteriasForMinPrices";

let DestinationItemView = Backbone.View.extend({
	el: '<li class="item decoratedSimpleCheckbox"></li>',
	events: {
		'click': 'selectItem'
	},
	selectItem: function (event) {
		var $selectedItem = this.$el,
			setItems = [],
			selectedData = this.model.get('itemsData'),
			currentSelectedResorts = this.parentModel.get('selectedItems'),
			addMulti = this.parentModel.get('addMulti');

		this.parent.emptyDestination = false;

		if (selectedData instanceof CountryEntity) {
			this.parentModel.set('selectedItems', new CountriesRepository(selectedData), {
				initiator: 'destView',
				updateList: true
			});
			this.parentView.scrollListToTop();
			$.cookie('countrySelected', 1, {path: '/'});
		}

		if (selectedData instanceof ResortEntity) {
			if (addMulti) {
				if (currentSelectedResorts instanceof ResortsRepository && currentSelectedResorts.at(0).get('country') == selectedData.get('country')) {
					if (currentSelectedResorts.contains(selectedData)) {
						setItems = currentSelectedResorts.without(selectedData);
						$selectedItem.removeClass('selected');
					} else {
						setItems = setItems.concat(currentSelectedResorts.models, selectedData);
						$selectedItem.addClass('selected');
					}
				} else {
					setItems.push(selectedData);
					$selectedItem.addClass('selected');
				}
			} else {
				setItems.push(selectedData);
				this.parentModel.set('controlActivated', false);
			}

			if (setItems && setItems.length) {
				this.parentModel.set('selectedItems', new ResortsRepository(setItems), {
					initiator: 'destView',
					updateList: true
				});
			} else {
				this.parentModel.set('selectedItems', new CountriesRepository(selectedData.get('country')), {
					initiator: 'destView',
					updateList: true
				});
			}

			$.cookie('countrySelected', 1, {path: '/'});
		}

		if (selectedData instanceof HotelEntity) {
			this.parentModel.set('selectedItems', new HotelsRepository(selectedData), {initiator: 'destView'});
			this.parentModel.set('controlActivated', false);
		}

		event.stopPropagation();
		event.preventDefault();
	},
	selectedAfterManualInput() {
		let inputValue = this.parentModel.get('inputString'),
			originalLabelChanged = this.parentModel.get('originalLabelChanged');

		return originalLabelChanged && !_.isEmpty(inputValue);
	},
	updateMinPrice: function () {
		var itemsData = this.model.get('itemsData'),
			minPrice = itemsData ? itemsData.get('minPrice') : false;

		if (minPrice) {
			this.$minPrice.html('от ' + (minPrice ? minPrice.formatNumber() : '') + ' р./чел.');
			this.$minPrice.addClass('show');
		} else {
			this.$minPrice.removeClass('show');
		}

	},
	generateItemDOM: function () {
		var getVisaInfo = function (country) {
				if (country.get('visaOnline')) {
					return 'онлайн-виза';
				} else if (country.get('visaRequired')) {
					return 'виза';
				} else {
					return 'без визы';
				}
			},
			type = this.model.get('type'),
			selectedCountryName,
			itemsData = this.model.get('itemsData'),
			selectedItems = this.model.get('selectedItems'),
			selectedOnlyOneCountry,
			text = '',
			$minPrice = '';

		switch (type) {
			case 'selectAll':
				selectedOnlyOneCountry = selectedItems && selectedItems.length == 1 && selectedItems instanceof CountriesRepository && selectedItems.at(0) instanceof CountryEntity;
				selectedCountryName = selectedOnlyOneCountry ? selectedItems.at(0).get('name') : itemsData.get('name');
				this.$el.append('<label><div class="checkbox-container"><input type="checkbox" class="checkboxInput"' + (selectedOnlyOneCountry ? ' checked' : '') + '><div class="checkbox"></div><span>Все курорты' + '<i>' + (selectedCountryName ? (', ' + selectedCountryName) : '') + '</i></span></div></label>');
				break;
			default:
				if (itemsData instanceof CountryEntity || itemsData instanceof ResortEntity) {
					this.$minPrice = $minPrice = $('<span class="minPrice"></span>');
					this.updateMinPrice();
				}

				text += '<label><div class="checkbox-container"><input type="checkbox" class="checkboxInput"' + (selectedItems && selectedItems && selectedItems.contains(itemsData) ? ' checked' : '') + '><div class="checkbox"></div>';

				if (itemsData instanceof CountryEntity) {
					text += '<span>' + itemsData.get('name') + '<span class="visaLabel">' + getVisaInfo(itemsData) + '</span></span>';
				}

				if (itemsData instanceof ResortEntity) {
					text += '<span>' + itemsData.get('name') + ', ' + '<i>' + itemsData.get('country').get('name') + '</i></span>';
				}

				if (itemsData instanceof HotelEntity) {
					text += '<span>' + itemsData.get('name') + '</span>';
				}
				text += '</div></label>';

				this.$el.append($minPrice);
				this.$el.append(text);
		}
	},
	initModelEvents: function () {
		var itemsData = this.model.get('itemsData');
		if (this.$minPrice && (itemsData instanceof CountryEntity || itemsData instanceof ResortEntity)) {
			itemsData.on('change:minPrice', $.proxy(this.updateMinPrice, this));
		}
	},
	initialize: function (options) {
		this.parentModel = options.parentModel;
		this.parentView = options.parentView;
		this.model = new Backbone.Model({
			type: options.type,
			itemsData: options.itemsData,
			selectedItems: options.selectedItems ? options.selectedItems : null
		});
		this.parent = options.parent;
		this.generateItemDOM();
		this.initModelEvents();
	}
});

let ListOfOptionsView = Backbone.View.extend({
	generateOptionsList: function (options, context) {
		var $optionsList = $('<ul></ul>'),
			currentPopularCategory = false,
			resortsOrDestinations,
			selectedItems = this.model.get('selectedItems'),
			self = this,
			selectedOnlyOneCountry,
			$selectAllItem = '',
			itemsData;

		selectedItems = selectedItems && selectedItems.length ? selectedItems : null;
		selectedOnlyOneCountry = selectedItems && selectedItems.length == 1 && selectedItems instanceof CountriesRepository;

		if (context && context.resortsListWithFirstAll) {
			if (options && options.length && options[0] instanceof ResortEntity) {
				$selectAllItem = new DestinationItemView({
					parentModel: this.model,
					parentView: this,
					itemsData: options[0].get('country'),
					selectedItems: selectedItems,
					type: 'selectAll',
					parent: self.parent
				});
			} else if (selectedOnlyOneCountry) {
				$selectAllItem = new DestinationItemView({
					parentModel: this.model,
					parentView: this,
					selectedItems: selectedItems,
					type: 'selectAll',
					parent: self.parent
				});
			}

			$optionsList.append($selectAllItem.$el);
		}

		if (options && options.length) {
			_.each(options, function (option, index) {
				var $item,
					optionIsPopular = option.get('isPopular');

				if (context && context.showPopularLabels && !(selectedItems && selectedItems.contains(option)) && currentPopularCategory !== optionIsPopular) {
					currentPopularCategory = optionIsPopular;
					resortsOrDestinations = (option && option instanceof ResortEntity) ? 'курорты' : 'направления';
					$optionsList.append('<li class="category"><span>' + (currentPopularCategory ? ('Популярные ' + resortsOrDestinations) : 'Остальные ' + resortsOrDestinations) + '</span></li>')
				}

				if (option instanceof CountryEntity ||
					option instanceof ResortEntity ||
					option instanceof HotelEntity) {

					$item = new DestinationItemView({
						parentModel: self.model,
						parentView: self,
						itemsData: option,
						selectedItems: selectedItems,
						type: 'item',
						parent: self.parent
					});
				}

				if ($item && options[index + 1] && options[index + 1].constructor !== option.constructor) {
					$item.$el.addClass('lastOfType');
				}

				$optionsList.append($item.$el);
			});

			this.$el.removeClass('loading');
			this.$el.append($optionsList);
			this.$errorPlace.removeClass('invalid');
		} else if (options && options.length == 0 && !(context && context.resortsListWithFirstAll)) {
			this.$errorPlace.addClass('invalid');
			this.$el.append(this.nothingFoundLabel());
		} else if (context && context.resortsListWithFirstAll) {
			this.$el.addClass('loading');
			this.$errorPlace.removeClass('invalid');
			this.$el.append($optionsList);
		}
	},
	nothingFoundLabel: function () {
		return '<div class="nothingFound">Ничего не найдено</div>';
	},
	updateOptionsList: function (models, model, context) {
		var optionsList = this.model.get('optionsList');

		this.$el.empty();
		this.generateOptionsList(optionsList, context);
	},
	selectItemByModel: function (model) {
		var items = $('ul li', this.$el),
			selectItem;

		selectItem = _.find(items, function (item) {
			return $(item).data('item') == model;
		});

		$(selectItem).trigger('select');
	},
	scrollListToTop: function () {
		this.$el.scrollTop(0);
	},
	controlActivatedChanged: function () {
		this.scrollListToTop();
	},
	initModelEvents: function () {
		this.model.on('change:optionsList', $.proxy(this.updateOptionsList, this));
		this.model.on('change:controlActivated', $.proxy(this.controlActivatedChanged, this));
	},
	initialize: function (options) {
		this.$errorPlace = options.$errorPlace ? options.$errorPlace : null;
		this.initModelEvents();
		this.parent = options.parent;
	}
});

let DestinationView = Backbone.View.extend({
	destinationLabel: 'Страна, курорт или отель',
	searchFieldView: null,
	listOfOptionsView: null,
	countriesData: null,
	resortsData: null,
	hotelsData: null,
	emptyDestination: false,
	directionChanged: function (event, model, context) {
		var countriesData,
			resortsData,
			hotelsData;

		if (!this.emptyDestination) {
			if (!context || context.initiator !== 'destView') {
				countriesData = this.countriesData.get('model');
				resortsData = this.resortsData.get('model');
				hotelsData = this.hotelsData.get('model');

				if (model === null || (model && model.length == 0)) {
					if (countriesData == null) {
						this.model.set('selectedItems', null);
					} else if (model instanceof HotelsRepository) {
						if (hotelsData && hotelsData.length) {
							this.model.set('selectedItems', hotelsData);
						} else if (resortsData && resortsData.length) {
							this.model.set('selectedItems', resortsData);
						} else if (countriesData && countriesData.length) {
							this.model.set('selectedItems', countriesData);
						}
					}
				} else {
					if (hotelsData && hotelsData.length) {
						this.model.set('selectedItems', hotelsData);
					} else if (resortsData && resortsData.length) {
						this.model.set('selectedItems', resortsData);
					} else if (countriesData && countriesData.length) {
						this.model.set('selectedItems', countriesData);
					} else {
						this.model.set('selectedItems', false);
					}
				}
			}
		} else {
			this.model.set('selectedItems', []);
		}
	},
	getOptionsVariants: function () {
		var inputValue = this.model.get('inputString'),
			selectedItems = this.model.get('selectedItems'),
			originalLabelChanged = this.model.get('originalLabelChanged'),
			self = this;

		if (originalLabelChanged && !_.isEmpty(inputValue)) {
			this.destinationService.getOptions(inputValue, {
				success: function (optionsList) {
					optionsList = _.sortBy(optionsList, function (option) {
						return !(selectedItems && selectedItems.length && selectedItems.contains(option));
					});
					self.model.set('optionsList', optionsList);
					self.updateSelection();
					self.updateListOfOptions();
				}
			});
		} else {
			this.updateListOfOptions();
		}
	},
	updateSelection: function () {
		var optionsList = this.model.get('optionsList'),
			firstItem = optionsList && optionsList.length ? optionsList[0] : null,
			firstItemName = firstItem ? firstItem.get('name') : null,
			inputValue = this.model.get('inputString');

		if (firstItemName && firstItemName.toLowerCase() == inputValue.toLowerCase()) {
			if (firstItem instanceof CountryEntity) {
				this.emptyDestination = false;
				this.model.set('selectedItems', new CountriesRepository(firstItem), {initiator: 'destView'});
			} else if (firstItem instanceof ResortEntity) {
				this.emptyDestination = false;
				this.model.set('selectedItems', new ResortsRepository(firstItem), {initiator: 'destView'});
			} else if (firstItem instanceof HotelEntity) {
				this.emptyDestination = false;
				this.model.set('selectedItems', new HotelsRepository(firstItem), {initiator: 'destView'});
			}
		}
	},
	getOptionsList: function (callback) {
		var inputValue = this.model.get('inputString'),
			self = this,
			countries = CountriesRepository.repository,
			country,
			selectedResorts = this.model.get('selectedResorts'),
			selectedCountry = this.model.get('selectedCountry'),
			selectedHotels = this.model.get('selectedHotels'),
			originalLabelChanged = this.model.get('originalLabelChanged'),
			sortCountryResorts = function (resorts) {
				return resorts.sortBy(function (resort) {
					var resortsSelected = selectedResorts ? selectedResorts.contains(resort) : 0;
					return ((!resortsSelected * 1).toString() + (!resort.get('isPopular') * 1).toString() + resort.get('name')).toLowerCase();
				})
			};

		if (inputValue == "") {
			countries = countries.sortBy(function (country) {
				var countrySelected = (selectedCountry && selectedCountry.at(0) == country) ? 1 : 0;
				return (!countrySelected).toString() + (country.get('position') / 1000).toFixed(3);
			});
			callback({
				value: countries,
				context: {showPopularLabels: true}
			});
		} else {
			if (!originalLabelChanged && (selectedCountry || selectedResorts)) {
				selectedCountry = selectedCountry ? selectedCountry.at(0) : selectedResorts.at(0).get('country');

				self.model.set('optionsList', [], {showPopularLabels: true, resortsListWithFirstAll: true});
				selectedCountry.getResorts({
					success: function (countryResorts) {
						countryResorts = sortCountryResorts(countryResorts);
						callback({
							value: countryResorts,
							context: {
								showPopularLabels: true,
								resortsListWithFirstAll: true
							}
						});
					}
				});
			} else if (!originalLabelChanged && selectedHotels) {
				callback({
					value: selectedHotels.models,
					context: {
						showPopularLabels: false
					}
				});
			}
		}
	},
	updateListOfOptions: function () {
		var self = this;

		this.getOptionsList(function (data) {
			self.model.set('optionsList', data.value, data.context);
		});

	},
	inputChanged: function (model, item, context) {
		var inputValue = this.model.get('inputString'),
			self = this;

		if (context.initiator == "destView") {
			this.getOptionsVariants();
		}
	},
	selectedItemsChangedByView: function (event, model, context) {
		var selectedItems = this.model.get('selectedItems'),
			country = [],
			resorts = [],
			hotels = [];

		if (context && context.initiator == "destView") {
			if (selectedItems && selectedItems.length) {
				if (selectedItems instanceof HotelsRepository) {
					hotels = selectedItems.models;
					country = selectedItems.at(0).get('country');
				} else if (selectedItems instanceof ResortsRepository) {
					resorts = selectedItems.models;
					country = selectedItems.at(0).get('country');
				} else if (selectedItems instanceof CountriesRepository) {
					country = selectedItems.models;
				}

				this.resortsData.set('model', new ResortsRepository(resorts), {initiator: 'destView'});
				this.countriesData.set('model', new CountriesRepository(country), {initiator: 'destView'});
				this.resortsData.set('model', new ResortsRepository(resorts), {initiator: 'destView'});
				this.hotelsData.set('model', new HotelsRepository(hotels));
			} else {
				this.countriesData.set('model', null, {initiator: 'destView'});
			}
		}
	},
	controlActivatedChanged: function () {
		this.updateListOfOptions();
	},
	selectItemByModel: function (model) {
		this.listOfOptionsView.selectItemByModel(model);
	},
	selectedItemsChanged: function (event, model, context) {
		this.selectedItemsChangedByView(event, model, context);
		if (context && context.updateList) {
			this.updateListOfOptions();
			this.model.trigger('change:optionsList', null, null, {
				showPopularLabels: true,
				resortsListWithFirstAll: true
			});
		}
	},
	clearMinPrices: function () {
		CountriesRepository.repository.each(function (country) {
			country.set('minPrice', null);
		});

		ResortsRepository.repository.each(function (resort) {
			resort.set('minPrice', null);
		});
	},
	getMinPrices: function () {
		var country = this.countriesData.get('model').at(0),
			self = this,
			countries = country.collection.filter(function (country) {
				return _.isNull(country.get('minPrice')) && country.get('isPopular');
			}),
			resorts = country.get('resorts'),
			filteredResorts = resorts && resorts.length ? resorts.filter(function (resort) {
				return _.isNull(resort.get('minPrice')) && resort.get('isPopular');
			}) : [],
			departureCity = this.depatrureCity.get('model').get('id'),
			getMinPriceByCriteria = function (params) {

				var tourCriterias = tourCriteriasForMinPricesHydrator({
					departureCity: params.departureCity,
					countries: params.countries,
					resorts: params.resorts,
					currentTourCriteria: self.parentModel.getTourCriteria()
				});

				if (tourCriterias && tourCriterias.length) {
					getMinPriceByCriteriasService({
						tourCriterias: tourCriterias
					}, {
						success: function (data) {
							_.each(params.resorts, function (resort) {
								resort.set('minPrice', 0, {
									silent: true
								});
							});
							_.each(params.countries, function (country) {
								country.set('minPrice', 0, {
									silent: true
								});
							});

							_.each(data, function (destinationPrice) {
								var criteria = JSON.parse(destinationPrice.criteria);

								if (!_.isEmpty(criteria.resorts) && criteria.resorts.length == 1) {
									_.find(params.resorts, function (resort) {
										return resort.get('id') == criteria.resorts[0];
									}).set('minPrice', Math.round(destinationPrice.minPrice / 2));
								} else {
									_.find(params.countries, function (country) {
										return country.get('id') == criteria.countries[0];
									}).set('minPrice', Math.round(destinationPrice.minPrice / 2));
								}
							});
						}
					});
				}
			};

		if (resorts && resorts.length) {
			getMinPriceByCriteria({
				departureCity: departureCity,
				countries: countries,
				resorts: filteredResorts
			});
		} else {
			country.once('change:resorts', function (model, resorts) {
				resorts = resorts.filter(function (resort) {
					return !resort.get('minPrice') && resort.get('isPopular');
				});
				getMinPriceByCriteria({
					departureCity: departureCity,
					countries: countries,
					resorts: resorts
				});
			});
		}

	},
	departureCityChanged: function () {
		var countries = this.model.get('collection');
		if (countries && countries.length) {
			this.clearMinPrices();
			this.getMinPrices();
		}
	},
	nightRangeChanged: function (event, model, context) {
		if (model !== null && context.initiator == "view") {
			this.clearMinPrices();
		}
	},
	checkInDateRangeChanged: function (event, model, context) {
		if (model !== null && context.initiator == "view") {
			this.clearMinPrices();
		}
	},
	countriesDataChanged: function (model, value, context) {
		var self = this;
		clearTimeout(this.countriesDataChangedTimeout);
		this.countriesDataChangedTimeout = setTimeout(function () {
			if (value) {
				self.getMinPrices();
			}
		}, 1);
	},
	initModelEvents: function () {
		this.countriesData.on('change:model', $.proxy(this.directionChanged, this));
		this.resortsData.on('change:model', $.proxy(this.directionChanged, this));
		this.hotelsData.on('change:model', $.proxy(this.directionChanged, this));
		this.model.on('change:inputString', $.proxy(this.inputChanged, this));
		this.model.on('change:selectedItems', $.proxy(this.selectedItemsChanged, this));
		this.model.on('change:controlActivated', $.proxy(this.controlActivatedChanged, this));
	},

	initModelEventsForMinPrice: function () {
		this.depatrureCity.on('change:model', $.proxy(this.departureCityChanged, this));
		this.nightRange.on('change:model', $.proxy(this.nightRangeChanged, this));
		this.checkInDateRange.on('change:model', $.proxy(this.checkInDateRangeChanged, this));
		this.countriesData.on('change:model', $.proxy(this.countriesDataChanged, this));
	},
	isValid: function () {
		if (this.emptyDestination) {
			this.searchFieldView.showEmptyDestinationError();
			return false;
		} else {
			this.searchFieldView.hideEmptyDestinationError();
			return true;
		}
	},
	getDestinationModel() {
		return DestinationModel;
	},
	getDestinationSearchFieldView() {
		return DestinationSearchFieldView;
	},
	renderLabel: function () {
		$('.formInput > label', this.$el).text(this.destinationLabel);
	},
	initialize: function (options) {
		var destinationViewModel = new (this.getDestinationModel())();
		this.model = destinationViewModel;

		this.destinationService = new DestinationService();
		this.countriesData = options.countriesData ? options.countriesData : null;
		this.resortsData = options.resortsData ? options.resortsData : null;
		this.hotelsData = options.hotelsData ? options.hotelsData : null;
		this.parentModel = options.parentModel ? options.parentModel : null;


		if (options.emptyByDefault && !ls.get('tourCriteria')) {
			this.emptyDestination = true;
		}

		if (options.depatrureCity && options.nightRange && options.checkInDateRange) {
			this.depatrureCity = options.depatrureCity ? options.depatrureCity : null;
			this.nightRange = options.nightRange ? options.nightRange : null;
			this.checkInDateRange = options.checkInDateRange ? options.checkInDateRange : null;
			this.initModelEventsForMinPrice();
		}
		this.searchFieldView = new (this.getDestinationSearchFieldView())({
			el: $('.formInputPlace', this.$el),
			parent: this,
			model: destinationViewModel,
			dataLayerAnalytics: options.dataLayerAnalytics
		});

		this.listOfOptionsView = new ListOfOptionsView({
			el: $('.formDropdownContent', this.$el),
			$errorPlace: $('.formInputPlace', this.$el),
			parent: this,
			model: destinationViewModel
		});

		this.renderLabel();
		this.initModelEvents();
	}
});

export default DestinationView;
